import { Tabs } from 'antd';
import { AnimatedContainer, Box, ContentContainer } from 'components';
import PageToolbar from 'components/Layout/PageToolbar';
import { useCustomTranslation } from 'helpers/translationHelper';
import React, { useMemo, useState } from 'react';

import CalendarTab from './superadmin/CalendarTab';
import CompaniesTab from './superadmin/CompaniesTab';
import DispatchesTab from './superadmin/DispatchesTab';
import OverviewTab from './superadmin/OverviewTab';
import { useDashboardRange } from './superadmin/useDashboardRange';
import SuperadminAccessToken from './SuperadminAccessToken';

const SuperadminDashboard: React.FC = (): React.ReactElement => {
  const { tDashboard, t } = useCustomTranslation();
  const [activeTab, setActiveTab] = useState('overview');
  // Held here rather than per tab so switching tabs keeps the period the operator picked; each tab
  // renders the pickers itself, next to the data they apply to.
  const range = useDashboardRange();

  const items = useMemo(
    () => [
      {
        key: 'overview',
        label: tDashboard('tabs_overview'),
        children: <OverviewTab range={range} />
      },
      {
        key: 'dispatches',
        label: tDashboard('tabs_dispatches'),
        children: activeTab === 'dispatches' ? <DispatchesTab range={range} /> : null
      },
      {
        key: 'companies',
        label: tDashboard('tabs_companies'),
        children: activeTab === 'companies' ? <CompaniesTab range={range} /> : null
      },
      {
        key: 'calendar',
        label: tDashboard('tabs_calendar'),
        children: activeTab === 'calendar' ? <CalendarTab range={range} /> : null
      }
    ],
    [tDashboard, range, activeTab]
  );

  return (
    <AnimatedContainer>
      <PageToolbar title={t('mainMenu.dashboard')} actions={<SuperadminAccessToken />} />
      <ContentContainer>
        <Box>
          <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} />
        </Box>
      </ContentContainer>
    </AnimatedContainer>
  );
};

export default SuperadminDashboard;
